import { Module } from 'vuex';
import RootState from '../RootState';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { FiltersState } from './typings';

export const state: FiltersState = {
  byId: {},
};

const namespaced = true;

const userModule: Module<FiltersState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};

export default userModule;
